import { render, staticRenderFns } from "./ViewAssuranceStatement.vue?vue&type=template&id=7fe507a4&scoped=true"
import script from "./ViewAssuranceStatement.vue?vue&type=script&lang=js"
export * from "./ViewAssuranceStatement.vue?vue&type=script&lang=js"
import style0 from "./ViewAssuranceStatement.vue?vue&type=style&index=0&id=7fe507a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe507a4",
  null
  
)

export default component.exports